<template>
  <div class="table">
    <div class="table-header">
      <p>Hỏi đáp</p>
      <div>
        <!-- <input v-model="filterTerm" placeholder="Name"/> -->
        <button @click="addClick" class="add-new" v-if="$checkPermission('create_qna')">+ Thêm mới</button>
      </div>
    </div>

    <div class="table-section">
      <table>
        <thead>
          <tr>
            <th>STT</th>
            <th>Câu hỏi</th>
            <!-- <th>Trả lời</th> -->
            <th>Ẩn</th>
            <th>Hành động</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(ctt, i) in paginatedData" :key="i">
            <td>{{ (currentPage - 1) * pageSize + i + 1 }}</td>
            <td>{{ ctt.question_vn }}</td>
            <!-- <td>{{ ctt.answer_vn }}</td> -->
            <td>{{ subForBoolean(ctt.isActive) }}</td>
            <td>
              <div class="action-holder">
                <button style="background-color: #0298cf;" @click="editClick(ctt)"
                  v-if="$checkPermission('edit_qna')"><i class="fa-solid fa-pen-to-square"></i></button>
                <button style="background-color: #f80000;" @click="toggleAlert(ctt.id)"
                  v-if="$checkPermission('delete_qna')"><i class="fa-solid fa-trash"></i></button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="pagination">
      <div @click="changePage(currentPage - 1)" :disabled="currentPage === 1"><i class="fa-solid fa-angle-left"></i></div>
      <div @click="changePage(1)" v-if="currentPage !== 1">1</div>
      <div v-if="currentPage - 2 >= 1" style="cursor: auto;"><i class="fa-solid fa-ellipsis"></i></div>
      <div style="color: #0298cf; background: rgba(171, 171, 171, 0.2);">{{ currentPage }}</div>
      <div v-if="currentPage + 2 <= totalPages" style="cursor: auto;"><i class="fa-solid fa-ellipsis"></i></div>
      <div @click="changePage(totalPages)" v-if="currentPage !== totalPages">{{ totalPages }}</div>
      <div @click="changePage(currentPage + 1)" :disabled="currentPage === totalPages"><i class="fa-solid fa-angle-right"></i></div>
    </div>
  </div>

  <!-- Modal -->
  <base-modal :modalActive="modalActive" :modalTitle="modalTitle" @close="toggleModal" @vnTab="vnTab" @enTab="enTab" :hasLang="true" size="large">
    <div class="data-display" v-if="lang">
      <div class="box"> <p>Câu hỏi<span style="color: red;">*</span></p> </div>
      <textarea type="text" v-model="question_vn"></textarea>
    </div>

    <div class="data-display" v-if="!lang">
      <div class="box"> <p>Câu hỏi<span style="color: red;">*</span></p> </div>
      <textarea type="text" v-model="question_en"></textarea>
    </div>

    <div class="data-display" v-if="lang">
      <div class="box" > <p>Trả lời<span style="color: red;">*</span></p> </div>
      <div style="width: 900px;">
        <QuillEditor v-model:content="answer_vn" :contentType="'html'" toolbar="full" />
      </div>

      <!-- <textarea type="text" v-model="answer_vn"></textarea> -->
    </div>

    <div class="data-display" v-if="!lang">
      <div class="box" > <p>Trả lời<span style="color: red;">*</span></p> </div>
      <!-- <textarea type="text" v-model="answer_en"></textarea> -->
      <div style="width: 900px;">
        <QuillEditor v-model:content="answer_en" :contentType="'html'" toolbar="full" />
      </div>
    </div>

    <div class="data-display">
      <div class="cb-box"> <p>Ẩn<span style="color: red;">*</span></p> </div>
      <div>
        <label>
          <input id="cb" type="checkbox" :checked="isActive === false" v-model="isActive" :true-value="false" :false-value="null" />
          Có
        </label>

        <label>
          <input id="cb" type="checkbox" :checked="isActive === true" v-model="isActive" :true-value="true" :false-value="null" />
          Không
        </label>
      </div>
    </div>

    <div class="btn-container">
      <button :class="{ loading: requestLoading }" :disabled="requestLoading" v-if="id === 0" @click="createClick()">
        <p class="btn-text">Tạo</p>
      </button>
      <button :class="{ loading: requestLoading }" :disabled="requestLoading" v-if="id !== 0" @click="updateClick()">
        <p class="btn-text">Cập nhật</p>
      </button>
    </div>
  </base-modal>

  <alert-modal :modalActive="modalAlert" @close="toggleAlert(selectedId)"
    :requestLoading="requestLoading"
    @delete="deleteClick(selectedId)">
  </alert-modal>
</template>
<script>
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'
export default {
  components: {
    QuillEditor
  },
  data () {
    return {
      pageSize: 10,
      currentPage: 1,
      isValid: true,
      modalActive: false,
      modalAlert: false,
      modalTitle: '',
      filterTerm: '',
      selectedId: 0,
      isLoading: false,
      requestLoading: false,
      // data
      id: 0,
      question_vn: '',
      answer_vn: '',
      question_en: '',
      answer_en: '',
      isActive: true,
      lang: true,
      propertiesToCheck: ['question_vn', 'question_en', 'answer_vn', 'answer_en', 'isActive']
    }
  },
  computed: {
    getQuestions () {
      return this.$store.getters['question/backendQuestion']
    },
    filterItems () {
      if (!this.filterTerm) {
        return this.getQuestions
      }
      this.reloadPageWithFilter()
      const searchTerm = this.filterTerm.toLowerCase()
      return this.getQuestions.filter(data =>
        data.companyName.toLowerCase().includes(searchTerm)
      )
    },
    paginatedData () {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.filterItems.slice(start, end)
    },
    totalPages () {
      const tp = Math.ceil(this.filterItems.length / this.pageSize)
      if (tp === 0) return 1
      return tp
    }
  },
  methods: {
    changePage (page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page
      }
    },
    reloadPageWithFilter () {
      this.currentPage = 1
    },
    toggleModal () {
      this.modalActive = !this.modalActive
    },
    toggleAlert (id) {
      this.selectedId = id
      this.modalAlert = !this.modalAlert
    },
    async getQuestionData () {
      this.isLoading = true
      await this.$store.dispatch('question/getQuestionAdminData')
      this.isLoading = false
    },
    subForBoolean (value) {
      if (value) return 'Không'
      else return 'Có'
    },
    vnTab () {
      this.lang = true
    },
    enTab () {
      this.lang = false
    },
    addClick () {
      this.modalTitle = 'Thêm hỏi đáp'
      this.id = 0
      this.question_vn = ''
      this.question_en = ''
      this.answer_en = ''
      this.answer_vn = ''
      this.isActive = true
      this.lang = true
      this.toggleModal()
    },
    validateVariable () {
      this.isValid = true
      this.propertiesToCheck.forEach(key => {
        if (this[key] === '' || this[key] === null) {
          this.isValid = false
        }
      })
    },
    async createClick () {
      this.requestLoading = true
      this.validateVariable()
      if (!this.isValid) {
        this.requestLoading = false
        this.$showError('Thiếu thông tin cần thiết')
        return
      }
      const newQuestion = {
        question_vn: this.question_vn,
        question_en: this.question_en,
        answer_vn: this.answer_vn,
        answer_en: this.answer_en,
        isActive: this.isActive
      }

      try {
        await this.$store.dispatch('question/postQuestion', newQuestion)
        this.requestLoading = false
        this.$showSuccess('Tạo thành công')
        this.getQuestionData()
        this.toggleModal()
      } catch (error) {
        this.requestLoading = false
        if (error.response.data.error_message) {
          this.$showError(error.response.data.error_message)
        } else {
          this.$showError('Đã xảy ra lỗi không mong muốn')
        }
      }
    },
    editClick (data) {
      this.toggleModal()
      this.isValid = true
      this.modalTitle = 'Chỉnh sửa hỏi đáp'
      this.id = data.id
      this.question_vn = data.question_vn
      this.question_en = data.question_en
      this.answer_vn = data.answer_vn
      this.answer_en = data.answer_en
      this.isActive = data.isActive
      this.lang = true
    },
    async updateClick () {
      this.requestLoading = true
      this.validateVariable()
      if (!this.isValid) {
        this.requestLoading = false
        this.$showError('Thiếu thông tin cần thiết')
        return
      }
      const updatedQuestion = {
        id: this.id,
        question_vn: this.question_vn,
        question_en: this.question_en,
        answer_vn: this.answer_vn,
        answer_en: this.answer_en,
        isActive: this.isActive,
        updateBy: this.$store.state.id
      }

      try {
        await this.$store.dispatch('question/updateQuestion', updatedQuestion)
        this.requestLoading = false
        this.$showSuccess('Cập nhật thành công')
        this.getQuestionData()
        this.toggleModal()
      } catch (error) {
        this.requestLoading = false
        if (error.response.data.error_message) {
          this.$showError(error.response.data.error_message)
        } else {
          this.$showError('Đã xảy ra lỗi không mong muốn')
        }
      }
    },
    async deleteClick (id) {
      this.requestLoading = true
      await this.$store.dispatch('question/deleteQuestion', id)
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      if (this.filterItems.slice(start, end).length === 1 && this.currentPage > 1) {
        this.currentPage--
      }
      this.requestLoading = false
      this.toggleAlert()
      this.getQuestionData()
    }
  },
  created () {
    this.getQuestionData()
  }
}
</script>
<style scoped>
  .table {
    width: 100%;
  }

  .table-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    background-color: rgb(240, 240, 240);
    flex-wrap: wrap;
  }

  .table-header p {
    color: #000;
  }

  button {
    outline: none;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    padding: 10px;
    color: #fff;
  }

  .add-new {
    padding: 10px 20px;
    color: #fff;
    background-color: #0298cf;
  }

  .table-header input {
    padding: 10px 20px;
    margin: 0 10px;
    outline: none;
    border: 1px solid #0298cf;
    border-radius: 6px;
    color: #0298cf;
  }

  ::placeholder {
    color: #0298cf;
  }

  /* table-header end */

  .table-section {
    min-height: 590px;
  }

  table {
    width: 100%;
    table-layout: auto;
    min-width: 1000px;
    border-collapse: collapse;
  }

  thead th {
    position: sticky;
    top: 0;
    background-color: #0298cf;
    color: #fff;
    font-size: 15px;
    height: 50px;
  }

  th,td {
    border-bottom: 1px solid #dddddd;
    padding: 10px 20px;
    text-align: center;
    border-right: 1px solid #dddddd;
    border-left: 1px solid #dddddd;
  }

  td {
    text-align: left;
  }

  tr:hover td {
    background-color: #cfe2ff;
  }

  .action-holder {
    display: flex;
    justify-content: space-around;
  }

  ::-webkit-scrollbar{
    height: 5px;
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3)
  }

  ::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3)
  }

  tr:nth-child(even) {background-color: #ececec }

  th:nth-child(1), td:nth-child(1) {
    text-align: center;
    width: 70px;
  }

  th:nth-child(3), td:nth-child(3) {
    text-align: center;
    width: 90px;
  }

  th:nth-child(4), td:nth-child(4) {
    text-align: center;
    width: 120px;
  }

  /* table end */

  .pagination {
    display: flex;
    justify-content: flex-end;
    width: 100%;
    padding: 20px 20px;
  }

  .pagination div{
    padding: 10px;
    border: 1px solid #d5d0d0;
    height: 40px;
    width: 40px;
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #0298cf;
    color: #fff;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.75);
    margin: 0 5px;
    cursor: pointer;
  }

  /* modal */

  .data-display {
    display: flex;
    align-items: center;
    margin-bottom: 30px;
    /* border: 2px solid #000; */
  }

  .data-display .cb-box {
    width: 100px;
  }

  .data-display .box {
    width: 120px;
  }

  .data-display input {
    height: 40px;
    width: 100%;
    border-radius: 6px;
    font-size: 17px;
    border: 1px solid #d9d9d9;
    padding: 0px 10px;
  }

  .data-display textarea{
    height: 80px;
    width: 100%;
    border-radius: 6px;
    font-size: 17px;
    border: 1px solid #d9d9d9;
    padding: 5px 10px;
  }

  .data-display #cb {
    height: 12px;
    width: auto;
    border-radius: 6px;
    font-size: 17px;
    border: 1px solid #d9d9d9;
    padding: 0px 7px;
    margin-right: 10px;
  }

  .data-display label {
    margin-right: 80px;
  }

  .data-display #special-label {
    margin-right: 66px;
  }

  .btn-container {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 30px;
  }

  .btn-container button {
    position: relative;
    padding: 12px 30px;
    color: #fff;
    background-color: #0298cf;
  }

  .loading .btn-text {
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease;
  }

  .loading::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    pointer-events: none;
    width: 25px;
    height: 25px;
    border-radius: 50%;
    border: 3px solid transparent;
    border-top-color: white;
    border-right-color: white;
    animation: loading 1s ease infinite;
  }

  @keyframes loading {
    0% {
      transform: rotate(0turn);
    }
    100% {
      transform: rotate(1turn);
    }
  }

  .errors {
    font-weight: bold;
    color: red;
  }

  .data-display select {
    height: 40px;
    width: 100%;
    border-radius: 6px;
    font-size: 17px;
    border: 1px solid #d9d9d9;
    padding: 0px 7px;
  }
</style>
